import { motion } from "framer-motion";

export default function StandardSection() {
  return (
    <section className="relative py-24 sm:py-28 px-5 sm:px-8 overflow-hidden">
      <span aria-hidden="true" className="text-stroke font-display font-black uppercase absolute bottom-0 right-0 text-[20vw] leading-none select-none pointer-events-none whitespace-nowrap">
        Risultati
      </span>
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-16 items-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-blood font-semibold mb-5">// Lo standard DisciplinaFit</p>
          <blockquote className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            «Non promettiamo <span className="text-blood">scorciatoie.</span>»
          </blockquote>
          <p className="mt-6 text-neutral-300 text-base sm:text-lg leading-relaxed max-w-xl">
            Ti diamo la rotta esatta per raggiungere il miglior stato di forma della tua vita:
            misurazioni precise, schede costruite su di te e la disciplina di chi non salta mai una
            seduta.
          </p>
          <ul className="mt-8 space-y-3">
            {["Anamnesi corporea come punto di partenza", "Schede rinnovate gratis ogni 45 giorni (Trimestrale, Semestrale, Annuale)", "File Excel interattivo incluso in ogni pacchetto"].map((item) => (
              <li key={item} className="flex items-start gap-3 text-neutral-200 text-sm sm:text-base">
                <span className="w-2 h-2 bg-blood rotate-45 inline-block mt-1.5 shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative max-w-md mx-auto lg:ml-auto w-full"
        >
          <div aria-hidden="true" className="absolute -inset-0 translate-x-4 -translate-y-4 border border-blood/50" />
          <img
            src="/coach-standard.jpg"
            alt="Standard atletico DisciplinaFit — definizione muscolare"
            loading="lazy"
            data-testid="standard-coach-photo"
            className="relative w-full aspect-[3/4] object-cover object-top contrast-125 saturate-[0.85]"
          />
          <div className="absolute bottom-5 left-5 bg-ink-deep/90 backdrop-blur border border-white/10 px-4 py-2.5">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-blood font-semibold">Definizione reale</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
